import CaseFirstView from 'components/cases/common/CasesFirstView/'
import OverView from 'components/cases/common/Overview/'
// import Interview from 'components/cases/peachjohn/Interview/Interview'
import CaseStudy from 'components/home/CaseStudy'
import { firstViewItem, overviewTitle, overviewItem, issueSolutionItems } from './PeachjohnItems'
import FooterCTA from 'components/common/FooterCTA'

const Peachjohn = (): JSX.Element => {
  return (
    <section>
      <CaseFirstView firstViewItem={firstViewItem} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      {/* <Interview /> */}
      <FooterCTA />
      <CaseStudy enTitle="Case study" jaTitle="事例" tagType="h2" />
    </section>
  )
}

export default Peachjohn
